import {
  type VirtualPageViewEvent,
  virtualPageViewEventSchema
} from './pageViewTrackingEventSchema';
import logger from '../logger';

export type VirtualPageViewEventProps = Omit<VirtualPageViewEvent, 'event'>;

export const buildVirtualPageViewEvent = (
  props: VirtualPageViewEventProps
): VirtualPageViewEvent | null => {
  const event: VirtualPageViewEvent = { event: 'virtual_page_view', ...props };

  const result = virtualPageViewEventSchema.safeParse(event);

  let builtEvent: VirtualPageViewEvent | null = null;
  if (result.success) {
    builtEvent = result.data;
  } else {
    logger.error(result.error, 'Invalid virtual page view event');
  }

  return builtEvent;
};

export default buildVirtualPageViewEvent;
